import { toBig } from "@tradingApp/components/Trading/helpers/big";
import type { BigSource, RoundingMode } from "big.js";

type RoundingDirection = "floor" | "ceil" | "round";

interface Params {
  value: BigSource;
  decimalPlaces: BigSource;
  roundingDirection?: RoundingDirection;
}

export function customRound(params: Params): string {
  const { value, decimalPlaces, roundingDirection = "floor" } = params;
  const multiplier = getMultiplier(decimalPlaces);

  return toBig(value)
    .times(multiplier)
    .round(0, getRoundingMode(roundingDirection))
    .div(multiplier)
    .toFixed();
}

function getMultiplier(decimalPlaces: BigSource): BigSource {
  const dpBig = toBig(decimalPlaces);

  return toBig(10).pow(dpBig.toNumber());
}

function getRoundingMode(roundingDirection?: RoundingDirection): RoundingMode {
  switch (roundingDirection) {
    case "round":
      return 1;
    case "ceil":
      return 3;
    default:
      return 0;
  }
}
